import React from 'react';

import { IconButton } from '@mui/material';
import { ArrowUp, Plus } from 'lucide-react';
import { AlineTooltip } from 'src/components/generic/AlineTooltip';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  footer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 1, 1, 1),
  },
  iconButton: {
    padding: theme.spacing(0.25),
  },
  mentionButton: {
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    backgroundColor: theme.appColors.primary,
    color: theme.palette.common.white,
  },
  submitButton: {
    color: theme.appColors.iconsType,
  },
}));

interface ActivityEditorFooterProps {
  onOpenMentions: () => void;
  mentionDisabled?: boolean;
  mentionTooltip?: string;
  onSubmit?: () => void;
  showSubmit?: boolean;
  submitDisabled?: boolean;
  submitTooltip?: string;
}

export function ActivityEditorFooter({
  mentionDisabled = false,
  mentionTooltip = 'Add context',
  onOpenMentions,
  onSubmit,
  showSubmit = true,
  submitDisabled = false,
  submitTooltip = 'Submit',
}: ActivityEditorFooterProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.footer}>
      <AlineTooltip arrow placement="top" title={mentionTooltip}>
        <span>
          <IconButton
            aria-label={mentionTooltip}
            className={`${classes.iconButton} ${classes.mentionButton}`}
            disabled={mentionDisabled}
            size="small"
            onClick={onOpenMentions}
          >
            <Plus size={16} strokeWidth={2.25} />
          </IconButton>
        </span>
      </AlineTooltip>
      {showSubmit && onSubmit && (
        <AlineTooltip arrow placement="top" title={submitTooltip}>
          <span>
            <IconButton
              aria-label={submitTooltip}
              className={`${classes.iconButton} ${classes.submitButton}`}
              disabled={submitDisabled}
              size="small"
              onClick={onSubmit}
            >
              <ArrowUp size={16} />
            </IconButton>
          </span>
        </AlineTooltip>
      )}
    </div>
  );
}
